import React, { useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useQuery } from 'react-query';
import ProductsV2Sidebar from './components/Sidebar';
import { getVendors } from '../../../api/vendors';
import SaveProductModal from '../../../componentsV2/Products/SaveProductModal';
import './styles.scss';
import ProductContainer from './components/Container';

const GET_VENDORS_PARAMS = {
  offset: 0,
  limit: 100,
  enabled: true,
};

const ProductsV2 = props => {
  const searchParams = useMemo(() => new URLSearchParams(window.location.search), []);
  const vendorIdParam = useMemo(() => Number(searchParams.get('vendorId')), [searchParams]);
  const flags = useFlags();

  const [selectedFilter, setSelectedFilter] = useState(vendorIdParam || 'allProducts');
  const [selectedAddProduct, setSelectedAddProduct] = useState(null);
  const [showAddProductModal, setShowAddProductModal] = useState(false);

  const handleOnSuccessSave = useCallback(({ id, image, name, ...rest }) => {
    if (!id) return;
    setSelectedAddProduct({ id, image, name, ...rest });
  }, []);

  const { data: vendors } = useQuery(
    'getVendors',
    async () =>
      getVendors({
        params: GET_VENDORS_PARAMS,
      }),
    {
      refetchOnWindowFocus: false,
      select: response => response?.data?.data,
      initialData: [],
    },
  );

  return (
    <div className="products-v2">
      <div className="products-v2__container">
        <ProductsV2Sidebar
          vendors={vendors}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          showAddProductModal={showAddProductModal}
          setShowAddProductModal={setShowAddProductModal}
        />
        <ProductContainer vendors={vendors} selectedFilter={selectedFilter} selectedAddProduct={selectedAddProduct} />
      </div>

      <SaveProductModal open={showAddProductModal} setOpen={setShowAddProductModal} onSuccess={handleOnSuccessSave} />
    </div>
  );
};

const mapStateToProps = state => ({
  paymentBanner: state.paymentBanner,
  auth: state.auth,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsV2);
